import React, { useEffect } from "react";
import ContentBox from "../../components/ContentBox/ContentBox";
import Heading from "../../components/Heading/Heading";
import { events } from "../../data/contents";

function Codeverse() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      <Heading text="Memory Archive" subtext="VYUHAA'23" />
      <ContentBox
        desc={events.memory.desc}
        venue={events.memory.venue}
        moreVenue={events.memory.moreVenue}
        time={events.memory.time}
        contacts={events.memory.contact}
        rounds={events.memory.round}
        teamSize={events.memory.teamSize}
        img_src={events.memory.img_src}
      />
    </div>
  );
}

export default Codeverse;